"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _Disable2FAModal = _interopRequireDefault(require("./Disable2FAModal"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _userActions = require("../../redux/actions/userActions");
var _reduxForm = require("redux-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  changeFieldValue: _reduxForm.change
};
var FORM = 'disable2FAModal';
var containerForm = (0, _reduxForm.reduxForm)({
  form: FORM,
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _reduxForm.reset)(FORM, 'code'));
    dispatch((0, _reduxForm.untouch)(FORM, 'code'));
    if (payload.otp) {
      return dispatch((0, _userActions.disable2FA)(payload.otp));
    }
    if (payload.code) {
      return dispatch((0, _userActions.disable2FA)(payload.code));
    }
    return dispatch((0, _reduxForm.reset)(FORM));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(_Disable2FAModal["default"]);
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(containerForm);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.DISABLE_2FA
})(container);